var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"carousel",staticClass:"carousel carousel--is-loading d-none d-lg-block"},[_vm._t("default")],2),_c('div',{staticClass:"scroller d-lg-none"},[_c('horizontal-scrolling-container',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }